import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import getColor from "@insite/mobius/utilities/getColor";
import "@midland-industries/Store/CustomerPartNumberReducer";
import "@midland-industries/Store/Data/CustomerLogos/CustomerLogosReducer";
import "@midland-industries/Store/Data/DynamicForms/DynamicFormReducer";
import "@midland-industries/Store/Data/NewProducts/NewProductsReducer";
import "@midland-industries/Store/Pages/CustomerPartNumber/CustomerPartsHistoryReducer";
import "@midland-industries/Store/Pages/OpenOrders/XcOpenOrdersReducer";
import "@midland-industries/Store/Pages/RequestRma/XcRequestRmaReducer";
import "@midland-industries/Store/Reducers";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
if (!IS_PRODUCTION) {
    // load all widget extensions. They could be loaded individually instead
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

// Post Style Guide
setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 590, 768, 1030, 1430],
        maxWidths: [540, 570, 730, 1000, 1400],
    },
    typography: {
        fontFamilyImportUrl:
            "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
        body: {
            fontFamily: "'Lato', sans-serif",
            css: css`
                > h5.mi-h5 {
                    color: white;
                    background-color: ${getColor("primary.main")};
                    padding-left: 5px;
                }
            `,
        },
        headerPrimary: {
            fontFamily: "'Lato', sans-serif",
        },
        headerSecondary: {
            fontFamily: "'Lato', sans-serif",
        },
        headerTertiary: {
            fontFamily: "'Lato', sans-serif",
        },
        h5: {
            css: css`
                &.mi-h5 {
                    color: white;
                    background-color: ${getColor("primary.main")};
                    padding-left: 8px;
                    margin-bottom: 6px;
                }
            `,
        },
    },
    focus: {
        width: "0px",
    },
});
